import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Tooltip, CircularProgress, Collapse } from '@mui/material';
import { Lock, Casino } from '@mui/icons-material';
import '../styles/WikiClasses.css';

// -- Composant Roulette Ecaflip ------------------------------------------------
const ROULETTE_DATA = [
  { cat: 'legendary', items: [
    { pct: '0.01%', name: 'Mort Maudite',   effect: 'Tue un Allié au hasard',   type: 'cursed' },
    { pct: '0.01%', name: 'Mort Divine',     effect: 'Tue un Ennemi au hasard',  type: 'divine' },
  ]},
  { cat: 'rare', items: [
    { pct: '1.50%', name: 'Invisibilité Maudite', effect: 'Rend un ennemi aléatoire invisible (1 tour)',  type: 'cursed' },
    { pct: '1.50%', name: 'Invisibilité Divine',  effect: 'Rend un allié aléatoire invisible (1 tour)',   type: 'divine' },
    { pct: '1.00%', name: 'Passe Maudite',        effect: 'Passe tour de tous les alliés',                type: 'cursed' },
    { pct: '1.00%', name: 'Passe Divine',          effect: 'Passe tour de tous les ennemis',               type: 'divine' },
  ]},
  { cat: 'buff', label: 'Buffs / Debuffs ciblés', items: [
    { pct: '2.00%', name: 'Puissance Divine',       effect: '+5% toutes stats élémentaires aux alliés',      type: 'divine' },
    { pct: '2.00%', name: 'Puissance Maudite',      effect: '+5% toutes stats élémentaires aux ennemis',     type: 'cursed' },
    { pct: '2.00%', name: 'Action Divine',           effect: '+2 PA aux alliés',                              type: 'divine' },
    { pct: '2.00%', name: 'Action Maudite',          effect: '+2 PA aux ennemis',                             type: 'cursed' },
    { pct: '2.00%', name: 'Mobilité Divine',         effect: '+3 PM aux alliés',                              type: 'divine' },
    { pct: '2.00%', name: 'Mobilité Maudite',        effect: '+3 PM aux ennemis',                             type: 'cursed' },
    { pct: '2.00%', name: 'Portée Divine',           effect: '+4 PO aux alliés',                              type: 'divine' },
    { pct: '2.00%', name: 'Portée Maudite',          effect: '+4 PO aux ennemis',                             type: 'cursed' },
    { pct: '2.00%', name: 'Critique Divine',         effect: '100% Crit aux alliés',                          type: 'divine' },
    { pct: '2.00%', name: 'Critique Maudite',        effect: '100% Crit aux ennemis',                         type: 'cursed' },
    { pct: '1.49%', name: 'Soin Divin',              effect: 'Soigne de 10% des PV max les alliés',           type: 'divine' },
    { pct: '1.49%', name: 'Soin Maudit',             effect: 'Soigne de 10% des PV max les ennemis',          type: 'cursed' },
  ]},
  { cat: 'debuff', label: 'Malus ciblés', items: [
    { pct: '2.00%', name: 'Faiblesse Maudite',        effect: '-5% toutes stats élémentaires aux alliés',    type: 'cursed' },
    { pct: '2.00%', name: 'Faiblesse Divine',         effect: '-5% toutes stats élémentaires aux ennemis',   type: 'divine' },
    { pct: '2.00%', name: 'Ralentissement Maudit',    effect: '-2 PA aux alliés',                            type: 'cursed' },
    { pct: '2.00%', name: 'Ralentissement Divin',     effect: '-2 PA aux ennemis',                           type: 'divine' },
    { pct: '2.00%', name: 'Maladresse Maudite',       effect: '-3 PM aux alliés',                            type: 'cursed' },
    { pct: '2.00%', name: 'Maladresse Divine',         effect: '-3 PM aux ennemis',                           type: 'divine' },
    { pct: '2.00%', name: 'Réduction Maudite',        effect: '-4 PO aux alliés',                            type: 'cursed' },
    { pct: '2.00%', name: 'Réduction Divine',         effect: '-4 PO aux ennemis',                           type: 'divine' },
    { pct: '2.00%', name: 'NoCrit Maudit',            effect: '0% Crit aux alliés',                          type: 'cursed' },
    { pct: '2.00%', name: 'NoCrit Divin',             effect: '0% Crit aux ennemis',                         type: 'divine' },
  ]},
  { cat: 'common', label: 'Effets aléatoires', items: [
    { pct: '7.00%', name: 'Stats Alliés',              effect: '+5% et +200 sur 1 stat aléatoire aux alliés',              type: 'divine' },
    { pct: '7.00%', name: 'Stats Ennemis',             effect: '+5% et +200 sur 1 stat aléatoire aux ennemis',             type: 'cursed' },
    { pct: '7.00%', name: 'Malus Stats Alliés',        effect: '-5% et -200 sur 1 stat aléatoire aux alliés',              type: 'cursed' },
    { pct: '7.00%', name: 'Malus Stats Ennemis',       effect: '-5% et -200 sur 1 stat aléatoire aux ennemis',             type: 'divine' },
    { pct: '6.00%', name: 'Dommage Alliés',            effect: '+10 Dégâts de base des sorts et CaC aux alliés',           type: 'divine' },
    { pct: '6.00%', name: 'Dommage Ennemis',           effect: '+10 Dégâts de base des sorts et CaC aux ennemis',          type: 'cursed' },
    { pct: '6.00%', name: 'Malus Dommage Alliés',      effect: '-10 Dégâts de base des sorts et CaC aux alliés',           type: 'cursed' },
    { pct: '6.00%', name: 'Malus Dommage Ennemis',     effect: '-10 Dégâts de base des sorts et CaC aux ennemis',          type: 'divine' },
  ]},
];

function EcaflipRouletteDetails() {
  const [open, setOpen] = useState(false);
  const typeColor = (t) => t === 'divine' ? '#4FC3F7' : '#FF7043';
  const typeIcon  = (t) => t === 'divine' ? 'D' : 'M';
  const catColors = { legendary: '#C9CED6', rare: '#D5A777', buff: '#81C784', debuff: '#E57373', common: '#90A4AE' };
  const catLabels = { legendary: 'Légendaire', rare: 'Rare', buff: 'Buffs / Debuffs ciblés', debuff: 'Malus ciblés', common: 'Effets aléatoires' };

  return (
    <Box sx={{ mt: 1.5 }}>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: 'inline-flex', alignItems: 'center', gap: 0.8,
          cursor: 'pointer', userSelect: 'none',
          p: '6px 14px', borderRadius: '8px',
          background: open ? 'rgba(244,67,54,0.15)' : 'rgba(244,67,54,0.08)',
          border: '1px solid rgba(244,67,54,0.3)',
          transition: 'all 0.2s',
          '&:hover': { background: 'rgba(244,67,54,0.18)', border: '1px solid rgba(244,67,54,0.5)' },
        }}
      >
        <Casino sx={{ fontSize: '1.1rem', color: '#F44336' }} />
        <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: '#F44336', letterSpacing: '0.03em' }}>
          {open ? 'Masquer' : 'Voir'} la table de la roulette
        </Typography>
        <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.4)', ml: 0.3, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>?</Typography>
      </Box>

      <Collapse in={open} timeout={300}>
        <Box sx={{ mt: 1.5, borderRadius: '10px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(0,0,0,0.25)' }}>
          {/* Header */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '10px 14px', background: 'rgba(244,67,54,0.1)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <Casino sx={{ fontSize: '1rem', color: '#F44336' }} />
            <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#fff' }}>Roulette de l'Ecaflip</Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.4)', ml: 'auto' }}>38 résultats possibles</Typography>
          </Box>

          {/* Légende */}
          <Box sx={{ display: 'flex', gap: 2, p: '8px 14px', borderBottom: '1px solid rgba(255,255,255,0.06)', flexWrap: 'wrap' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: '#4FC3F7' }} />
              <Typography sx={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)' }}>Divin (favorable)</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: '#FF7043' }} />
              <Typography sx={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)' }}>Maudit (défavorable)</Typography>
            </Box>
          </Box>

          {/* Sections par catégorie */}
          {ROULETTE_DATA.map((section) => (
            <Box key={section.cat}>
              <Box sx={{ p: '6px 14px', background: 'rgba(255,255,255,0.02)', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                <Typography sx={{ fontSize: '0.74rem', fontWeight: 700, color: catColors[section.cat], textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                  {catLabels[section.cat]}
                </Typography>
              </Box>
              {section.items.map((item, i) => (
                <Box key={i} sx={{
                  display: 'flex', alignItems: 'center', gap: 1, p: '5px 14px',
                  borderBottom: '1px solid rgba(255,255,255,0.03)',
                  '&:hover': { background: 'rgba(255,255,255,0.03)' },
                  transition: 'background 0.15s',
                }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: catColors[section.cat], minWidth: 42, textAlign: 'right' }}>{item.pct}</Typography>
                  <Typography sx={{ fontSize: '0.72rem', color: typeColor(item.type), minWidth: 10 }}>{typeIcon(item.type)}</Typography>
                  <Typography sx={{ fontSize: '0.78rem', fontWeight: 600, color: 'rgba(255,255,255,0.85)', minWidth: 170 }}>{item.name}</Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.55)', flex: 1 }}>{item.effect}</Typography>
                </Box>
              ))}
            </Box>
          ))}

          {/* Footer */}
          <Box sx={{ p: '8px 14px', background: 'rgba(255,255,255,0.02)', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.35)', fontStyle: 'italic', textAlign: 'center' }}>
              La roulette s'active automatiquement à chaque sort lancé par l'Ecaflip • Total : 100%
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

const SORTS_BASE = '/assets/sorts/';

// -- Données des 12 classes avec mapping vers les dossiers locaux ----------
// folder: nom exact du sous-dossier dans public/assets/sorts/{classFolder}/
// null = pas de carte locale disponible
const CLASSES_DATA = [
  {
    id: 1,
    name: 'Féca',
    classFolder: 'Feca',
    available: true,
    color: '#4CAF50',
    spells: [
      { id: 3,    name: 'Attaque Naturelle',       folder: 'Attaque naturelle' },
      { id: 17,   name: 'Glyphe Agressif',          folder: 'Glyphe aggressif' },
      { id: 6,    name: 'Armure Terrestre',          folder: 'Armure Terrestre' },
      { id: 4,    name: 'Renvoi de Sort',            folder: null },
      { id: 2,    name: 'Aveuglement',               folder: null },
      { id: 1,    name: 'Armure Incandescente',      folder: 'Armure Incandescente' },
      { id: 9,    name: 'Attaque Nuageuse',          folder: 'Attaque nuageuse' },
      { id: 18,   name: 'Armure Aqueuse',            folder: 'Armure Aqueuse' },
      { id: 20,   name: 'Immunité',                  folder: null },
      { id: 14,   name: 'Armure Venteuse',           folder: 'Armure Venteuse' },
      { id: 19,   name: 'Bulle',                     folder: 'Bulle' },
      { id: 5,    name: 'Tréve',                     folder: null },
      { id: 16,   name: 'Science du béton',          folder: null },
      { id: 8,    name: 'Retour du béton',           folder: null },
      { id: 12,   name: "Glyphe d'Aveuglement",      folder: null },
      { id: 11,   name: 'Téléportation',             folder: null },
      { id: 10,   name: 'Glyphe Enflammé',           folder: 'Glyphe enflammé' },
      { id: 7,    name: 'Bouclier Féca',             folder: 'Bouclier Feca' },
      { id: 15,   name: "Glyphe d'Immobilisation",   folder: null },
      { id: 13,   name: 'Glyphe de Silence',         folder: null },
      { id: 1901, name: 'Invocation de Dopeul Féca', folder: null },
      { id: 422,  name: 'Mise en garde',             folder: null },
    ],
  },
  {
    id: 2,
    name: 'Osamodas',
    classFolder: 'Osamodas',
    available: true,
    color: '#8BC34A',
    spells: [
      { id: 23,   name: "Cri de l'Ours",                    folder: null },
      { id: 34,   name: 'Invocation de Tofu',               folder: 'Invocation #1' },
      { id: 21,   name: 'Griffe Spectrale',                  folder: null },
      { id: 26,   name: 'Bénédiction Animale',               folder: null },
      { id: 22,   name: 'Déplacement Félin',                 folder: 'Déplacement felin' },
      { id: 35,   name: 'Invocation de Bouftou',             folder: 'Invocation #2' },
      { id: 28,   name: 'Crapaud',                           folder: null },
      { id: 37,   name: 'Invocation de Prespic',             folder: 'Invocation #3' },
      { id: 30,   name: 'Fouet',                             folder: null },
      { id: 27,   name: 'Piqére Motivante',                  folder: 'Piqure motivante' },
      { id: 24,   name: 'Corbeau',                           folder: null },
      { id: 33,   name: 'Griffe Cinglante',                  folder: 'Griffe cinglante' },
      { id: 25,   name: 'Soin Animal',                       folder: 'Soin animal' },
      { id: 38,   name: 'Invocation de Sanglier',            folder: 'Invocation #4' },
      { id: 36,   name: 'Frappe du Craqueleur',              folder: 'Frappe du craqueleur' },
      { id: 32,   name: 'Résistance Naturelle',              folder: null },
      { id: 29,   name: 'Crocs du Mulou',                    folder: 'Croc du mulou' },
      { id: 39,   name: 'Invocation de Bwork Mage',          folder: null },
      { id: 40,   name: 'Invocation de Craqueleur',          folder: null },
      { id: 31,   name: 'Invocation de Dragonnet Rouge',     folder: null },
      { id: 1902, name: 'Invocation de Dopeul Osamodas',     folder: null },
      { id: 420,  name: 'Laisse Spirituelle',                folder: null },
    ],
  },
  {
    id: 3,
    name: 'Enutrof',
    classFolder: 'Enutrof',
    available: true,
    color: '#FF9800',
    spells: [
      { id: 51,   name: 'Lancer de Piéces',              folder: 'Lancer de piéces' },
      { id: 41,   name: 'Sac Animé',                     folder: 'Sac animé' },
      { id: 43,   name: 'Lancer de Pelle',               folder: null },
      { id: 49,   name: 'Pelle Fantomatique',             folder: 'Pelle Fantomatique' },
      { id: 42,   name: 'Chance',                        folder: null },
      { id: 47,   name: 'Boîte de Pandore',              folder: null },
      { id: 48,   name: 'Remblai',                       folder: 'Remblai' },
      { id: 45,   name: 'Clé Réductrice',                folder: null },
      { id: 53,   name: "Force de l'Age",                folder: null },
      { id: 46,   name: 'Désinvocation',                 folder: null },
      { id: 52,   name: 'Cupidité',                      folder: null },
      { id: 44,   name: 'Roulage de Pelle',              folder: 'Roulage de pelle' },
      { id: 50,   name: 'Maladresse',                    folder: null },
      { id: 54,   name: 'Maladresse de Masse',           folder: null },
      { id: 55,   name: 'Accélération',                  folder: 'Acceleration' },
      { id: 56,   name: 'Pelle du Jugement',             folder: 'Pelle du jugement' },
      { id: 58,   name: 'Pelle Massacrante',             folder: 'Pelle Massacrante' },
      { id: 59,   name: 'Corruption',                    folder: null },
      { id: 57,   name: 'Pelle Animée',                  folder: 'Pelle animée' },
      { id: 60,   name: 'Coffre Animé',                  folder: 'Coffre animé' },
      { id: 1903, name: 'Invocation de Dopeul Enutrof',  folder: null },
      { id: 425,  name: 'Retraite anticipée',            folder: null },
    ],
  },
  {
    id: 4,
    name: 'Sram',
    classFolder: 'Sram',
    available: true,
    color: '#B67A3C',
    spells: [
      { id: 65,   name: 'Piège Sournois',              folder: 'Piège sournois' },
      { id: 72,   name: 'Invisibilité',                folder: 'Invisibilité' },
      { id: 61,   name: 'Sournoiserie',                folder: 'Sournoiserie' },
      { id: 66,   name: 'Poison insidieux',            folder: null },
      { id: 68,   name: 'Fourvoiement',                folder: null },
      { id: 63,   name: 'Coup Sournois',               folder: 'Coup sournois' },
      { id: 74,   name: 'Double',                      folder: 'Double' },
      { id: 64,   name: 'Repérage',                    folder: 'Repérage' },
      { id: 79,   name: 'Piège de Masse',              folder: 'Piège de masse' },
      { id: 78,   name: "Invisibilité d'Autrui",       folder: "Invisibilité d'autrui" },
      { id: 71,   name: 'Piège Empoisonné',            folder: null },
      { id: 62,   name: 'Concentration de Chakra',     folder: null },
      { id: 69,   name: "Piège d'Immobilisation",      folder: null },
      { id: 77,   name: 'Piège de Silence',            folder: null },
      { id: 73,   name: 'Piège Répulsif',              folder: null },
      { id: 67,   name: 'Peur',                        folder: null },
      { id: 70,   name: 'Arnaque',                     folder: null },
      { id: 75,   name: 'Pulsion de Chakra',           folder: null },
      { id: 76,   name: 'Attaque Mortelle',            folder: 'Attaque mortelle' },
      { id: 80,   name: 'Piège Mortel',                folder: 'Piège mortel' },
      { id: 1904, name: 'Invocation de Dopeul Sram',   folder: null },
      { id: 416,  name: 'Poisse',                      folder: null },
    ],
  },
  {
    id: 5,
    name: 'Xélor',
    classFolder: 'Xelor',
    available: true,
    color: '#2196F3',
    spells: [
      { id: 81,   name: 'Ralentissement',              folder: null },
      { id: 83,   name: 'Aiguille',                    folder: null },
      { id: 82,   name: 'Contre',                      folder: null },
      { id: 84,   name: 'Gelure',                      folder: null },
      { id: 100,  name: 'Sablier de Xélor',            folder: 'Sablier du xelor' },
      { id: 92,   name: 'Rayon Obscur',                folder: 'Rayon obscur' },
      { id: 88,   name: 'Téléportation',               folder: 'Téléportation' },
      { id: 93,   name: 'Flétrissement',               folder: 'Flétrissement' },
      { id: 85,   name: 'Flou',                        folder: null },
      { id: 96,   name: 'Poussiére Temporelle',        folder: null },
      { id: 98,   name: 'Vol du Temps',                folder: null },
      { id: 86,   name: 'Aiguille Chercheuse',         folder: null },
      { id: 89,   name: 'Dévouement',                  folder: 'Dévouement' },
      { id: 90,   name: 'Fuite',                       folder: 'Fuite' },
      { id: 87,   name: 'Démotivation',                folder: null },
      { id: 94,   name: 'Protection Aveuglante',       folder: null },
      { id: 99,   name: 'Momification',                folder: 'Momification' },
      { id: 95,   name: 'Horloge',                     folder: 'Horloge' },
      { id: 91,   name: 'Frappe de Xélor',             folder: 'Frappe du xelor' },
      { id: 97,   name: 'Cadran de Xélor',             folder: 'Cadran' },
      { id: 1905, name: 'Invocation de Dopeul Xélor',  folder: null },
      { id: 424,  name: 'Raulebaque',                  folder: null },
    ],
  },
  {
    id: 6,
    name: 'Ecaflip',
    classFolder: 'Ecaflip',
    available: true,
    color: '#F44336',
    spells: [
      { id: 102,  name: 'Pile ou Face',                    folder: 'Pile ou face' },
      { id: 103,  name: "Chance d'Ecaflip",                folder: null },
      { id: 105,  name: 'Bond du Félin',                   folder: 'Bond du felin' },
      { id: 109,  name: 'Bluff',                           folder: 'Bluff' },
      { id: 113,  name: 'Perception',                      folder: null },
      { id: 111,  name: 'Contrecoup',                      folder: null },
      { id: 104,  name: 'Tréfle',                          folder: null },
      { id: 119,  name: 'Tout ou rien',                    folder: 'Tout ou rien', maxLevel: 2 },
      { id: 101,  name: 'Roulette',                        folder: null },
      { id: 107,  name: 'Topkaj',                          folder: 'Topkaj' },
      { id: 116,  name: 'Langue Répeuse',                  folder: 'Langue répeuse' },
      { id: 106,  name: 'Roue de la Fortune',              folder: null },
      { id: 117,  name: 'Griffe Invocatrice',              folder: 'Griffe invocatrice' },
      { id: 108,  name: 'Esprit Félin',                    folder: null },
      { id: 115,  name: 'Odorat',                          folder: null },
      { id: 118,  name: 'Réflexes',                        folder: null },
      { id: 110,  name: 'Griffe Joueuse',                  folder: null },
      { id: 112,  name: 'Griffe de Ceangal',               folder: 'Griffe de Ceangal' },
      { id: 114,  name: 'Rekop',                           folder: 'Rekop' },
      { id: 120,  name: "Destin d'Ecaflip",                folder: "Destin d'Ecaflip" },
      { id: 1906, name: 'Invocation de Dopeul Ecaflip',    folder: null },
      { id: 412,  name: 'Félintion',                       folder: null },
    ],
  },
  {
    id: 7,
    name: 'Eniripsa',
    classFolder: 'Eniripsa',
    available: true,
    color: '#00BCD4',
    spells: [
      { id: 125,  name: 'Mot Interdit',                      folder: 'Mot interdit' },
      { id: 128,  name: 'Mot de Frayeur',                    folder: null },
      { id: 121,  name: 'Mot Curatif',                       folder: 'Mot Curatif' },
      { id: 124,  name: 'Mot Soignant',                      folder: null },
      { id: 122,  name: 'Mot Blessant',                      folder: null },
      { id: 126,  name: 'Mot Stimulant',                     folder: 'Mot stimulant' },
      { id: 127,  name: 'Mot de Prévention',                 folder: null },
      { id: 123,  name: 'Mot Drainant',                      folder: 'Mot drainant' },
      { id: 130,  name: 'Mot Revitalisant',                  folder: 'Mot Revitalisant' },
      { id: 131,  name: 'Mot de Régénération',               folder: 'Mot de régénération' },
      { id: 132,  name: "Mot d'Epine",                       folder: null },
      { id: 133,  name: 'Mot de Jouvence',                   folder: 'Mot de jouvence' },
      { id: 134,  name: 'Mot Vampirique',                    folder: 'Mot Vampirique' },
      { id: 135,  name: 'Mot de Sacrifice',                  folder: null },
      { id: 129,  name: "Mot d'Amitié",                      folder: "Mot d'amitié" },
      { id: 136,  name: "Mot d'Immobilisation",              folder: null },
      { id: 137,  name: "Mot d'Envol",                       folder: null },
      { id: 138,  name: 'Mot de Silence',                    folder: null },
      { id: 139,  name: "Mot d'Altruisme",                   folder: null },
      { id: 140,  name: 'Mot de Reconstitution',             folder: 'Mot de reconstitution' },
      { id: 1907, name: 'Invocation de Dopeul Eniripsa',     folder: null },
      { id: 427,  name: 'Mot Lotof',                         folder: null },
    ],
  },
  {
    id: 8,
    name: 'Iop',
    classFolder: 'Iop',
    available: true,
    color: '#E53935',
    spells: [
      { id: 142,  name: 'Bond',                         folder: 'Bond' },
      { id: 143,  name: 'Intimidation',                 folder: 'Intimidation' },
      { id: 141,  name: 'Pression',                     folder: 'Pression' },
      { id: 144,  name: 'Compulsion',                   folder: null },
      { id: 145,  name: 'Epée Divine',                  folder: null },
      { id: 146,  name: 'Epée du destin',               folder: null },
      { id: 147,  name: 'Guide de Bravoure',            folder: 'Guide de bravoure' },
      { id: 148,  name: 'Amplification',                folder: null },
      { id: 154,  name: 'Epée Destructrice',            folder: null },
      { id: 150,  name: 'Couper',                       folder: null },
      { id: 151,  name: 'Souffle',                      folder: null },
      { id: 155,  name: 'Vitalité',                     folder: null },
      { id: 152,  name: 'Epée du Jugement',             folder: 'Epee du jugement' },
      { id: 153,  name: 'Puissance',                    folder: 'Puissance' },
      { id: 149,  name: 'Mutilation',                   folder: null },
      { id: 156,  name: 'Tempéte de Puissance',         folder: 'Tempete de puissance' },
      { id: 157,  name: 'Epée Céleste',                 folder: 'Epee celeste' },
      { id: 158,  name: 'Concentration',                folder: null },
      { id: 160,  name: 'Epée de Iop',                  folder: 'Epee de Iop' },
      { id: 159,  name: 'Colére de Iop',                folder: 'Colére de Iop' },
      { id: 1908, name: 'Invocation de Dopeul Iop',     folder: null },
      { id: 410,  name: 'Brokle',                       folder: null },
    ],
  },
  {
    id: 9,
    name: 'Crâ',
    classFolder: 'Cra',
    available: true,
    color: '#66BB6A',
    spells: [
      { id: 169,  name: 'Fléche de Recul',              folder: 'Fléche de recul' },
      { id: 164,  name: 'Fléche Empoisonnée',           folder: null },
      { id: 161,  name: 'Fléche Magique',               folder: null },
      { id: 163,  name: 'Fléche Glacée',                folder: null },
      { id: 165,  name: 'Flèche Enflammée',             folder: null },
      { id: 172,  name: 'Tir Éloigné',                  folder: null },
      { id: 167,  name: "Flèche d'Expiation",           folder: "Flèche d'expiation" },
      { id: 168,  name: 'Œil de Taupe',                 folder: 'Œil de taupe' },
      { id: 162,  name: 'Tir Critique',                 folder: null },
      { id: 170,  name: "Flèche d'Immobilisation",      folder: null },
      { id: 171,  name: 'Flèche Punitive',              folder: 'Flèche Punitive' },
      { id: 166,  name: 'Tir Puissant',                 folder: 'Tir puissant' },
      { id: 173,  name: 'Flèche Harcelante',            folder: 'Flèche harcelante' },
      { id: 174,  name: 'Flèche Cinglante',             folder: 'Flèche cinglante' },
      { id: 176,  name: 'Flèche Persécutrice',          folder: null },
      { id: 175,  name: 'Flèche Destructrice',          folder: null },
      { id: 178,  name: 'Flèche Absorbante',            folder: null },
      { id: 177,  name: 'Flèche Ralentissante',         folder: 'Flèche Ralentissante' },
      { id: 179,  name: 'Flèche Explosive',             folder: 'Flèche Explosive' },
      { id: 180,  name: "Maîtrise de l'Arc",            folder: "maitrise de l'arc" },
      { id: 1909, name: 'Invocation de Dopeul Crâ',     folder: null },
      { id: 418,  name: 'Flèche de Dispersion',         folder: null },
    ],
  },
  {
    id: 10,
    name: 'Sadida',
    classFolder: 'Sadida',
    available: true,
    color: '#43A047',
    spells: [
      { id: 193,  name: 'La Bloqueuse',                      folder: null },
      { id: 183,  name: 'Ronce',                             folder: 'Ronce' },
      { id: 200,  name: 'Poison Paralysant',                 folder: null },
      { id: 198,  name: 'Sacrifice Poupesque',               folder: null },
      { id: 195,  name: 'Larme',                             folder: null },
      { id: 182,  name: 'La Folle',                          folder: null },
      { id: 192,  name: 'Ronce Apaisante',                   folder: null },
      { id: 197,  name: 'Puissance Sylvestre',               folder: 'Puissance Sylvestre' },
      { id: 189,  name: 'La Sacrifiée',                      folder: 'Invocation Sacrifiée' },
      { id: 181,  name: 'Tremblement',                       folder: 'Tremblement' },
      { id: 199,  name: 'Connaissance des Poupées',          folder: null },
      { id: 191,  name: 'Ronces Multiples',                  folder: 'Ronce multiples' },
      { id: 186,  name: 'Arbre',                             folder: 'Arbre' },
      { id: 196,  name: 'Vent Empoisonné',                   folder: null },
      { id: 190,  name: 'La Gonflable',                      folder: null },
      { id: 194,  name: 'Ronces Agressives',                 folder: 'Ronces aggressives' },
      { id: 185,  name: 'Herbe Folle',                       folder: null },
      { id: 184,  name: 'Feu de Brousse',                    folder: 'Feu de brousses' },
      { id: 188,  name: 'Ronce Insolente',                   folder: 'Ronce insolente' },
      { id: 187,  name: 'La Surpuissante',                   folder: 'Invocation La surpuissante' },
      { id: 1910, name: 'Invocation de Dopeul Sadida',       folder: null },
      { id: 426,  name: 'Arbre de vie',                      folder: null },
    ],
  },
  {
    id: 11,
    name: 'Sacrieur',
    classFolder: 'Sacrieur',
    available: true,
    color: '#EF5350',
    spells: [
      { id: 431,  name: 'Chétiment Forcé',              folder: 'Chatiment Forcé' },
      { id: 432,  name: 'Pied du Sacrieur',             folder: 'Pied du sacrieur' },
      { id: 434,  name: 'Attirance',                    folder: 'Attirance' },
      { id: 444,  name: 'Dérobade',                     folder: null },
      { id: 449,  name: 'Détour',                       folder: 'Détour' },
      { id: 436,  name: 'Assaut',                       folder: null },
      { id: 437,  name: 'Chétiment Agile',              folder: 'Chatiment Agile' },
      { id: 439,  name: 'Dissolution',                  folder: 'Dissolution' },
      { id: 433,  name: 'Chétiment Osé',                folder: 'Chatiment Osé' },
      { id: 443,  name: 'Chétiment Spirituel',          folder: 'Chatiment Spirituel' },
      { id: 440,  name: 'Sacrifice',                    folder: null },
      { id: 442,  name: 'Absorption',                   folder: null },
      { id: 441,  name: 'Chétiment Vitalesque',         folder: null },
      { id: 445,  name: 'Coopération',                  folder: 'Coopération' },
      { id: 438,  name: 'Transposition',                folder: 'Transposition' },
      { id: 446,  name: 'Punition',                     folder: null },
      { id: 447,  name: 'Furie',                        folder: null },
      { id: 448,  name: 'Epée volante',                 folder: null },
      { id: 435,  name: 'Transfert de Vie',             folder: null },
      { id: 450,  name: 'Folie sanguinaire',            folder: null },
      { id: 1911, name: 'Invocation de Dopeul Sacrieur',folder: null },
      { id: 421,  name: 'Douleur partagée',             folder: null },
    ],
  },
  {
    id: 12,
    name: 'Pandawa',
    classFolder: 'Pandawa',
    available: true,
    color: '#FF7043',
    spells: [
      { id: 686,  name: 'Picole',                          folder: null },
      { id: 692,  name: 'Gueule de Bois',                  folder: null },
      { id: 687,  name: 'Poing Enflammé',                  folder: null },
      { id: 689,  name: 'Epouvante',                       folder: 'épouvante' },
      { id: 690,  name: 'Souffle Alcoolisé',               folder: null },
      { id: 691,  name: 'Vulnérabilité Aqueuse',           folder: 'Vulnérabilité aqueuse' },
      { id: 688,  name: 'Vulnérabilité Incandescente',     folder: 'Vulnérabilité incandescente' },
      { id: 693,  name: 'Karcham',                         folder: 'karcham' },
      { id: 694,  name: 'Vulnérabilité Venteuse',          folder: 'Vulnérabilité venteuse' },
      { id: 695,  name: 'Stabilisation',                   folder: null },
      { id: 696,  name: 'Chamrak',                         folder: 'chamrak' },
      { id: 697,  name: 'Vulnérabilité Terrestre',         folder: 'Vulnérabilité terrestre' },
      { id: 698,  name: 'Souillure',                       folder: null },
      { id: 699,  name: 'Lait de Bambou',                  folder: null },
      { id: 700,  name: 'Vague à Lame',                    folder: null },
      { id: 701,  name: 'Colère de Zatoïshwan',            folder: null },
      { id: 702,  name: 'Flasque Explosive',               folder: 'Flasque Explosive' },
      { id: 703,  name: 'Pandatak',                        folder: null },
      { id: 704,  name: 'Pandanlku',                       folder: null },
      { id: 705,  name: 'Lien Spiritueux',                 folder: 'Lien spiritueux' },
      { id: 1912, name: 'Invocation de Dopeul Pandawa',    folder: null },
      { id: 423,  name: 'Ivresse',                         folder: null },
    ],
  },
];

// -- Icônes éléments ------------------------------------------------------
const ELEM_ICONS = {
  feu:    '/assets/elements/feu.svg',
  eau:    '/assets/elements/eau.svg',
  air:    '/assets/elements/air.svg',
  terre:  '/assets/elements/terre.svg',
  neutre: '/assets/elements/neutre.svg',
};

// -- Descriptions des classes ----------------------------------------------
const CLASS_DESCRIPTIONS = {
  1:  "Gardiens de l'ordre et maîtres des glyphes, les Féca protègent leurs alliés grâce à de puissantes armures élémentaires et des zones offensives redoutables.",
  2:  "Invocateurs de créatures, les Osamodas dominent le champ de bataille par le nombre et la diversité de leurs familiers.",
  3:  "Chasseurs de trésors rusés, les Enutrof possèdent un talent unique pour exploiter la chance et affaiblir leurs adversaires.",
  4:  "Maîtres de l'ombre et du piège, les Sram excellent dans l'assassinat furtif et la manipulation du terrain.",
  5:  "Manipulateurs du temps, les Xélor volent les PA de leurs ennemis et contrôlent le tour de jeu avec une précision chirurgicale.",
  6:  "Joueurs invétérés, les Ecaflip s'en remettent au destin pour infliger des dégâts dévastateurs autant que pour se soigner.",
  7:  "Guérisseurs sacrés, les Eniripsa maîtrisent l'art du soin et du debuff pour maintenir leurs alliés en vie.",
  8:  "Guerriers brutaux, les Iop foncent dans le tas et infligent des dégâts colossaux grâce à leur force brute et leurs épées divines.",
  9:  "Archers de précision, les Crâ excellent à longue portée et contrôlent le terrain grâce à leurs flèches aux effets variés.",
  10: "Maîtres des poupées et de la nature, les Sadida invoquent des alliés végétaux et empoisonnent leurs ennemis de loin.",
  11: "Guerriers du sacrifice, les Sacrieurs canalisent la souffrance pour décupler leur puissance au combat.",
  12: "Bretteurs alcoolisés, les Pandawa portent et lancent leurs ennemis tout en les enivrant grâce à leurs sorts uniques.",
};

// -- Passifs des classes (lorem ipsum en attendant le contenu définitif) -----
const CLASS_PASSIVES = {
  1:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Gardien des Glyphes
        </Typography>
      </Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#4CAF50', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>
          Fait perdre l'équivalent de la moitié des PM du Féca aux ennemis lorsqu'ils subissent des dégâts via glyphe.
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {['Le rall dure 1 tour', "L'effet ne se cumule pas via les différentes glyphes"].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', pt: 1.2, mt: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#4CAF50', mb: 0.8, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Spécificité</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mb: 0.6, fontSize: '0.82rem', lineHeight: 1.55 }}>
          Les glyphes du Féca font des dégâts :
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {['Au lancer', 'Lorsque le mob commence dessus', 'Lorsque le mob finit dessus'].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  ),
  2:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître des Invocations
        </Typography>
      </Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#8BC34A', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>+1 Invocation.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>Transfère 1 PA à ses invocations pour chaque invocation lui appartenant en jeu.</Typography>
      </Box>
      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', pt: 1.2, mt: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#8BC34A', mb: 0.8, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Spécificité</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem', lineHeight: 1.55 }}>
          5% de chance qu'un boss soit invoqué à chaque invocation.
        </Typography>
      </Box>
    </Box>
  ),
  3:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Chasseur de Fortune
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#FF9800', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>+10% Kamas.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>+10% de taux de drop fixe sur les items communs{' '}
          <Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(taux de base {'>'} 5%)</Box>
          , sinon +1%.
        </Typography>
      </Box>
    </Box>
  ),
  4:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître des Pièges
        </Typography>
      </Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#B67A3C', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.8 }}>
          Chaque piège déclenché par un mob et lui infligeant des dégâts fait apparaître d'autres pièges.
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {[
            'Les pièges apparaissent autour de la zone du piège initial',
            'Si un piège est déjà placé, ils ne se superposent pas',
            'Les pièges qui apparaissent sont les mêmes que celui qui a été déclenché',
            'Cela se produit une seule fois par piège',
          ].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', pt: 1.2, mt: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#B67A3C', mb: 0.8, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Spécificité</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem', lineHeight: 1.55 }}>
          Le Sram possède un double performant qui peut se mettre invisible, lancer des pièges (qui ont aussi le passif) et taper les mobs !
        </Typography>
      </Box>
    </Box>
  ),
  5:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître du Temps
        </Typography>
      </Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#2196F3', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.8 }}>
          À chaque tour, votre case de début de tour est marquée. Lorsque vous finissez votre tour, une image rémanente est créée sur votre case marquée du début de tour.
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {[
            "L'image rémanente utilise les mêmes sorts que vous, à chaque fois que vous tapez ou ralentissez (si elle l'a en ligne de vue)",
            "L'image rémanente ne peut pas bouger ou subir de dégâts",
            "L'image rémanente dure 2 tours, il est alors possible d'en avoir 2 au maximum",
          ].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  ),
  6:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître de la Chance
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#FF9800', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>
          À chaque lancer de sort, une roulette s'active ! (Effet 1 tour)
        </Typography>
      </Box>
      <EcaflipRouletteDetails />
    </Box>
  ),
  7:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Guérisseur Sacré
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#00BCD4', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>Les soins annulent l'érosion que la cible a subie à hauteur de 5% par sort de soin.</Typography>
      </Box>
    </Box>
  ),
  8:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Fureur du Iop
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#E53935', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>+1 PM.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>Toutes les 3 attaques infligées par le Iop, celui-ci se régénère de 5% de ses PV max.</Typography>
      </Box>
    </Box>
  ),
  9:  (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître de l'Arc
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#66BB6A', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>+1 PO.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem' }}>Pour chaque PM non utilisé, gagne 2% de dommages à partir du tour suivant{' '}
          <Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(2 tours)</Box>.
        </Typography>
      </Box>
    </Box>
  ),
  10: (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître de l'Infection
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#43A047', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>À chaque dégât infligé sur un ennemi, celui-ci devient infecté{' '}
          <Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(2 tours)</Box>.
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {['Une cible infectée subit 50% des dégâts', 'Sur un sort de zone, les cibles infectées ne reprennent pas les dégâts'].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  ),
  11: (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Guerrier du Sacrifice
        </Typography>
      </Box>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#EF5350', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>Toutes les sources de vitalité sont doublées.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.4 }}>Stacks de Concentration{' '}<Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(100% -&gt; 75% de vie)</Box>{' '}qui buffent les dommages de manière dégressive :</Typography>
        <Box component="ul" sx={{ margin: '2px 0 8px 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          <Box component="li" sx={{ mb: 0.4, lineHeight: 1.55 }}>Départ à 15% de dommages pour 100% de vie</Box>
        </Box>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.4 }}>Stacks de Souffrance{' '}<Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(65% -&gt; 10% de vie)</Box>{' '}qui buffent les dommages et la résistance de manière progressive :</Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          <Box component="li" sx={{ mb: 0.4, lineHeight: 1.55 }}>Départ à 5% de dommages et réduction de dégâts pour 65% de vie</Box>
        </Box>
      </Box>
    </Box>
  ),
  12: (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff', letterSpacing: 0.2 }}>
          Maître de l'Ivresse
        </Typography>
      </Box>
      <Box sx={{ mb: 0.5 }}>
        <Typography sx={{ fontWeight: 700, color: '#FF7043', mb: 0.6, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Passif</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>+10% Résistances All.</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.88)', lineHeight: 1.6, fontSize: '0.85rem', mb: 0.5 }}>À chaque fois que le Panda touche un ennemi, il lui ajoute un stack d'Alcoolémie{' '}
          <Box component="span" sx={{ color: 'rgba(255,255,255,0.45)', fontStyle: 'italic', fontSize: '0.9em' }}>(Stack Max : 5)</Box>.
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 6px 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          <Box component="li" sx={{ mb: 0.4, lineHeight: 1.55 }}>Chaque stack ajoute 5% de chances que la cible fasse n'importe quoi durant son tour.</Box>
        </Box>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mb: 0.6, fontSize: '0.82rem', lineHeight: 1.55 }}>
          Sous effet alcoolémique, le mob peut :
        </Typography>
        <Box component="ul" sx={{ margin: '2px 0 0 0', paddingLeft: '18px', color: 'rgba(255,255,255,0.75)', fontSize: '0.82rem' }}>
          {[
            'Se déplacer n\'importe où',
            'Taper dans le vide',
            'Frapper un de ses alliés',
          ].map((item, i) => (
            <Box component="li" key={i} sx={{ mb: 0.4, lineHeight: 1.55 }}>{item}</Box>
          ))}
        </Box>
      </Box>
    </Box>
  ),
};

// -- Correspondance classFolder -> nom JSON ---------------------------------
const JSON_FILE_MAP = {
  Feca:     'spells_feca.json',
  Osamodas: 'spells_osamodas.json',
  Enutrof:  'spells_enutrof.json',
  Sram:     'spells_sram.json',
  Xelor:    'spells_xelor.json',
  Ecaflip:  'spells_ecaflip.json',
  Eniripsa: 'spells_eniripsa.json',
  Iop:      'spells_iop.json',
  Cra:      'spells_cra.json',
  Sadida:   'spells_sadida.json',
  Sacrieur: 'spells_sacrieur.json',
  Pandawa:  'spells_pandawa.json',
};

// -- Utilitaires : zones de sorts -----------------------------------------
// Parse "2 (C)" -> { size: 2, type: 'C' }
function parseZone(text) {
  if (!text) return null;
  const m = text.match(/^(\d+)\s*\(([A-Za-z])\)$/);
  if (!m) return null;
  return { size: parseInt(m[1], 10), type: m[2].toUpperCase() };
}

// -- Composant : aperçu portée + zone interactive (style Solomonk) ---------
const RangeZoneDisplay = ({ spellLevel }) => {
  const [hovered, setHovered] = useState(null);

  const { po_min = 0, po_max = 0, lancer_en_ligne } = spellLevel;

  // Résoudre la zone : priorité à zone_texte des effets normaux, sinon champ zone du niveau
  const allEffects = [...(spellLevel.effets_normaux || []), ...(spellLevel.effets_critiques || [])];
  const foundZoneTexte = allEffects.find(e => e.zone_texte && e.zone_texte !== '-' && e.zone_texte !== 'Cellule' && e.zone_texte !== 'caché');
  let effectiveZone = foundZoneTexte ? foundZoneTexte.zone_texte : spellLevel.zone;

  const CELL = 13, GAP = 1;
  const displayRadius = Math.min(po_max, 6);
  const gridSize = displayRadius * 2 + 1;
  const gridPx   = gridSize * CELL + (gridSize - 1) * GAP;
  const wrapSize = Math.ceil(gridPx * Math.SQRT2) + 6;

  const isReachable = (r, c) => {
    if (r === 0 && c === 0) return po_min === 0;
    const dist = Math.abs(r) + Math.abs(c);
    if (dist < po_min || dist > displayRadius) return false;
    if (lancer_en_ligne && r !== 0 && c !== 0) return false;
    return true;
  };

  const getAoeCells = (hr, hc) => {
    const result = new Set([`${hr},${hc}`]);
    if (!effectiveZone || effectiveZone === '-' || effectiveZone === 'Cellule') return result;
    const parsed = parseZone(effectiveZone);
    if (!parsed) return result;
    const { size: s, type } = parsed;
    if (type === 'C' || type === 'Cb') {
      for (let dr = -s; dr <= s; dr++)
        for (let dc = -s; dc <= s; dc++)
          if (Math.abs(dr) + Math.abs(dc) <= s) result.add(`${hr+dr},${hc+dc}`);
    } else if (type === 'X') {
      // Croix cardinale (forme +) : bras N/S/E/O jusqu'à s cases
      for (let i = -s; i <= s; i++) {
        result.add(`${hr + i},${hc}`);
        result.add(`${hr},${hc + i}`);
      }
    } else if (type === 'L') {
      // Ligne : cases qui continuent dans la direction lanceur->cible
      const dr = hr === 0 ? 0 : (hr > 0 ? 1 : -1);
      const dc = hc === 0 ? 0 : (hc > 0 ? 1 : -1);
      for (let i = 1; i <= s; i++) {
        result.add(`${hr + dr*i},${hc + dc*i}`);
      }
    } else if (type === 'P') {
      // Perpendiculaire à la direction de lancer (lanceur -> cible)
      if (hr === 0) {
        // Tir horizontal -> zone verticale au point d'impact
        for (let i = -s; i <= s; i++) result.add(`${hr+i},${hc}`);
      } else if (hc === 0) {
        // Tir vertical -> zone horizontale au point d'impact
        for (let i = -s; i <= s; i++) result.add(`${hr},${hc+i}`);
      } else if (Math.abs(hr) >= Math.abs(hc)) {
        // Tir principalement vertical -> zone horizontale
        for (let i = -s; i <= s; i++) result.add(`${hr},${hc+i}`);
      } else {
        // Tir principalement horizontal -> zone verticale
        for (let i = -s; i <= s; i++) result.add(`${hr+i},${hc}`);
      }
    }
    return result;
  };

  const aoeCells = hovered ? getAoeCells(hovered.r, hovered.c) : null;
  const hasZone  = effectiveZone && effectiveZone !== '-' && effectiveZone !== 'Cellule';

  return (
    <div className="wc-range-section">
      <div className="wc-range-label">
        {hovered && hasZone && <span className="wc-range-zone-hint">zone {effectiveZone}</span>}
        {!hovered && hasZone && <span className="wc-range-zone-hint">survolez pour voir la zone</span>}
      </div>
      <div className="wc-range-wrap" style={{ width: wrapSize, height: wrapSize }}>
        <div
          className="wc-range-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${gridSize}, ${CELL}px)`,
            gridTemplateRows:    `repeat(${gridSize}, ${CELL}px)`,
            gap: `${GAP}px`,
          }}
        >
          {Array.from({ length: gridSize }, (_, ri) =>
            Array.from({ length: gridSize }, (_, ci) => {
              const r = ri - displayRadius, c = ci - displayRadius;
              const isCenter = r === 0 && c === 0;
              const reachable = isReachable(r, c);
              const inAoe = aoeCells?.has(`${r},${c}`);
              let cls = 'wc-range-cell';
              if (isCenter)               cls += inAoe ? ' wc-range-cell--aoe' : ' wc-range-cell--caster';
              else if (inAoe)            cls += ' wc-range-cell--aoe';
              else if (reachable)        cls += ' wc-range-cell--reach';
              else                       cls += ' wc-range-cell--empty';
              return (
                <div
                  key={`${r},${c}`}
                  className={cls}
                  onMouseEnter={() => !isCenter && reachable && setHovered({ r, c })}
                  onMouseLeave={() => setHovered(null)}
                />
              );
            })
          )}
        </div>
      </div>
      <div className="wc-range-legend">
        <span className="wc-range-dot wc-range-dot--caster" /> Lanceur
        <span className="wc-range-dot wc-range-dot--reach" /> Portée
        {aoeCells && <><span className="wc-range-dot wc-range-dot--aoe" /> Zone</>}
      </div>
      {po_max > 6 && (
        <div className="wc-range-note">Portée max : {po_max} PO (affichage limité à 6 PO)</div>
      )}
    </div>
  );
};

// -- Sous-composant : carte de sort détaillée ------------------------------
const SpellDetail = ({ spellData, classColor }) => {
  const [activeLevel, setActiveLevel] = useState(0);
  const [activeTab, setActiveTab] = useState('normal');
  useEffect(() => {
    setActiveLevel(0);
    setActiveTab('normal');
  }, [spellData?.id, spellData?.nom]);

  if (!spellData) return null;

  const levels = spellData.niveaux || [];
  const currentLevel = levels[activeLevel];
  if (!currentLevel) return null;

  const hasCC = currentLevel.effets_critiques && currentLevel.effets_critiques.length > 0;
  const effects = activeTab === 'normal' ? currentLevel.effets_normaux : currentLevel.effets_critiques;

  return (
    <div className="wc-spell-detail">
      {/* Header sort */}
      <div className="wc-sd-header">
        <img
          src={`/assets/spells/${spellData.icon_id ?? spellData.id}.svg`}
          alt={spellData.nom}
          className="wc-sd-icon"
          onError={(e) => { e.target.style.opacity = '0.3'; }}
        />
        <div className="wc-sd-header-info">
          <div className="wc-sd-name" style={{ color: classColor }}>{spellData.nom}</div>
          {spellData.description && (
            <div className="wc-sd-desc">{spellData.description}</div>
          )}
        </div>
      </div>

      {/* Sélecteur de niveaux */}
      <div className="wc-sd-levels">
        {levels.map((lvl, i) => (
          <button
            key={i}
            className={`wc-sd-level-btn${activeLevel === i ? ' active' : ''}`}
            style={activeLevel === i ? { borderColor: classColor, color: classColor, background: `${classColor}22` } : {}}
            onClick={() => setActiveLevel(i)}
          >
            Niv. {lvl.niveau_sort}
          </button>
        ))}
      </div>

      {/* Stats du niveau */}
      <div className="wc-sd-stats">
        <div className="wc-sd-stat">
          <span className="wc-sd-stat-label">PA</span>
          <span className="wc-sd-stat-val" style={{ color: classColor }}>{currentLevel.pa}</span>
        </div>
        <div className="wc-sd-stat">
          <span className="wc-sd-stat-label">Portée</span>
          <span className="wc-sd-stat-val">
            {currentLevel.po_min === currentLevel.po_max
              ? currentLevel.po_min
              : `${currentLevel.po_min} à ${currentLevel.po_max}`}
          </span>
        </div>
        {currentLevel.prob_cc && currentLevel.prob_cc !== '-' && (
          <div className="wc-sd-stat">
            <span className="wc-sd-stat-label">CC</span>
            <span className="wc-sd-stat-val">{currentLevel.prob_cc}</span>
          </div>
        )}
        {currentLevel.tours_entre_lancers && currentLevel.tours_entre_lancers !== '-' && (
          <div className="wc-sd-stat">
            <span className="wc-sd-stat-label">Relance</span>
            <span className="wc-sd-stat-val">{currentLevel.tours_entre_lancers}</span>
          </div>
        )}
        {currentLevel.lancers_par_tour && currentLevel.lancers_par_tour !== '-' && (
          <div className="wc-sd-stat">
            <span className="wc-sd-stat-label">Lancers/tour</span>
            <span className="wc-sd-stat-val">{currentLevel.lancers_par_tour}</span>
          </div>
        )}
        {currentLevel.lancers_par_cible && currentLevel.lancers_par_cible !== '-' && (
          <div className="wc-sd-stat">
            <span className="wc-sd-stat-label">Lancers/cible</span>
            <span className="wc-sd-stat-val">{currentLevel.lancers_par_cible}</span>
          </div>
        )}
        {currentLevel.lancers_par_tour_par_joueur && currentLevel.lancers_par_tour_par_joueur !== '-' && (
          <div className="wc-sd-stat">
            <span className="wc-sd-stat-label">Lancers/joueur</span>
            <span className="wc-sd-stat-val">{currentLevel.lancers_par_tour_par_joueur}</span>
          </div>
        )}

      </div>

      {/* Booléens */}
      <div className="wc-sd-bools">
        {currentLevel.portee_modifiable && <span className="wc-sd-bool">Portée modifiable</span>}
        {currentLevel.ligne_de_vue && <span className="wc-sd-bool">Ligne de vue</span>}
        {currentLevel.lancer_en_ligne && <span className="wc-sd-bool">En ligne</span>}
        {currentLevel.cellules_libres && <span className="wc-sd-bool">Cellules libres</span>}
        {currentLevel.ec_fini_tour && <span className="wc-sd-bool">EC fin de tour</span>}
      </div>

      {/* Portée interactive */}
      <RangeZoneDisplay spellLevel={currentLevel} />

      {/* Onglets Effets */}
      <div className="wc-sd-tabs">
        <button
          className={`wc-sd-tab${activeTab === 'normal' ? ' active' : ''}`}
          style={activeTab === 'normal' ? { borderBottomColor: classColor, color: classColor } : {}}
          onClick={() => setActiveTab('normal')}
        >
          Effets normaux
        </button>
        {hasCC && (
          <button
            className={`wc-sd-tab${activeTab === 'critique' ? ' active' : ''}`}
            style={activeTab === 'critique' ? { borderBottomColor: '#C9CED6', color: '#C9CED6' } : {}}
            onClick={() => setActiveTab('critique')}
          >
            Critiques
          </button>
        )}
      </div>

      {/* Liste des effets */}
      <div className="wc-sd-effects">
        {(!effects || effects.length === 0) ? (
          <div className="wc-sd-effect-empty">Aucun effet</div>
        ) : (
          effects.map((eff, i) => (
            <div key={i} className="wc-sd-effect-row">
              {eff.element && ELEM_ICONS[eff.element] && (
                <img src={ELEM_ICONS[eff.element]} alt={eff.element} className="wc-sd-elem-icon" />
              )}
              <span className="wc-sd-effect-text">{eff.texte}</span>
              {eff.zone_texte && eff.zone_texte !== '-' && eff.zone_texte !== 'Cellule' && eff.zone_texte !== 'caché' && eff.show_zone !== false && (
                <span className="wc-sd-zone-badge">{eff.zone_texte}</span>
              )}
            </div>
          ))
        )}
      </div>

      {/* Etats */}
      {spellData.etats_interdits && spellData.etats_interdits.length > 0 && (
        <div className="wc-sd-states">
          <span className="wc-sd-states-label">Interdit si :</span>
          {spellData.etats_interdits.map((e, i) => (
            <span key={i} className="wc-sd-state-tag">{e}</span>
          ))}
        </div>
      )}
      {spellData.etats_requis && spellData.etats_requis !== 'Aucun' && (
        <div className="wc-sd-states">
          <span className="wc-sd-states-label">Requis :</span>
          <span className="wc-sd-state-tag wc-sd-state-tag--req">{spellData.etats_requis}</span>
        </div>
      )}

    </div>
  );
};

// -- Composant principal ---------------------------------------------------
const WikiClasses = () => {
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSpell, setSelectedSpell] = useState(null);
  const [spellsJson, setSpellsJson] = useState(null);
  const [loadingSpells, setLoadingSpells] = useState(false);

  // Charge le JSON de sorts quand on sélectionne une classe
  useEffect(() => {
    if (!selectedClass) return;
    const jsonFile = JSON_FILE_MAP[selectedClass.classFolder];
    if (!jsonFile) return;
    setLoadingSpells(true);
    setSpellsJson(null);
    fetch(`/assets/sorts/${jsonFile}`, { cache: 'no-store' })
      .then(r => r.json())
      .then(data => setSpellsJson(data))
      .catch(() => setSpellsJson(null))
      .finally(() => setLoadingSpells(false));
  }, [selectedClass]);

  const handleClassClick = useCallback((cls) => {
    setSelectedClass(cls);
    setSelectedSpell(null);
  }, []);

  // Récupère les données JSON d'un sort par son nom
  const getSpellData = useCallback((spellName) => {
    if (!spellsJson?.sorts) return null;
    return spellsJson.sorts.find(s => s.nom === spellName) || null;
  }, [spellsJson]);

  // Tous les sorts du JSON (avec icônes disponibles)
  const allJsonSpells = spellsJson?.sorts || [];

  return (
    <Box className="wc-root">

      {/* -- Grille de sélection des classes ---------------------------- */}
      <Box className="wc-class-grid">
        {CLASSES_DATA.map((cls) => {
          const isActive = selectedClass?.id === cls.id;
          const isLocked = !cls.available;
          return (
            <Tooltip
              key={cls.id}
              title={isLocked ? 'Bientôt disponible' : cls.name}
              placement="top"
              arrow
            >
              <Box
                className={`wc-class-card${isActive ? ' wc-class-card--active' : ''}${isLocked ? ' wc-class-card--locked' : ''}`}
                onClick={() => !isLocked && handleClassClick(cls)}
                sx={{
                  '--cls-color': cls.color,
                  borderColor: isActive ? cls.color : 'rgba(255,255,255,0.08)',
                  boxShadow: isActive ? `0 0 0 2px ${cls.color}55, 0 8px 32px ${cls.color}33` : 'none',
                  opacity: isLocked ? 0.35 : 1,
                  cursor: isLocked ? 'not-allowed' : 'pointer',
                  filter: isLocked ? 'grayscale(1)' : 'none',
                  position: 'relative',
                }}
              >
                {isLocked && (
                  <Lock sx={{ position: 'absolute', top: 6, right: 6, fontSize: 14, color: 'rgba(255,255,255,0.5)' }} />
                )}
                <img
                  src={`/assets/classes/${cls.id}M.svg`}
                  alt={cls.name}
                  className="wc-class-img"
                  loading="lazy"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
                <Typography
                  className="wc-class-name"
                  sx={{ color: isActive ? cls.color : 'rgba(255,255,255,0.65)' }}
                >
                  {cls.name}
                </Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      {/* -- Vue détaillée d'une classe ---------------------------------- */}
      {selectedClass && (
        <Box className="wc-class-view">

          {/* Bannière de classe */}
          <Box className="wc-class-banner" style={{ '--cls-color': selectedClass.color }}>
            <img
              src={`/assets/classes/${selectedClass.id}M.svg`}
              alt={selectedClass.name}
              className="wc-class-banner-img"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <Box className="wc-class-banner-text">
              <Typography className="wc-class-banner-name" style={{ color: selectedClass.color }}>
                {selectedClass.name}
              </Typography>
              <Typography className="wc-class-banner-desc">
                {CLASS_DESCRIPTIONS[selectedClass.id] || ''}
              </Typography>
              {CLASS_PASSIVES[selectedClass.id] && (
                <Box className="wc-class-banner-passive">
                  {typeof CLASS_PASSIVES[selectedClass.id] === 'string'
                    ? <>
                        <span className="wc-passive-label" style={{ color: selectedClass.color }}>Passif</span>
                        <Typography className="wc-passive-text">{CLASS_PASSIVES[selectedClass.id]}</Typography>
                      </>
                    : <Box className="wc-passive-rich">{CLASS_PASSIVES[selectedClass.id]}</Box>
                  }
                </Box>
              )}
            </Box>
          </Box>

          {/* Contenu : liste sorts + détail */}
          <Box className="wc-class-content">

            {/* Colonne gauche : grille de sorts */}
            <Box className="wc-spell-list-col">
              <Box className="wc-spell-list-header" style={{ borderColor: `${selectedClass.color}44` }}>
                <Box className="wc-spells-header-dot" style={{ background: selectedClass.color }} />
                <Typography className="wc-spell-list-title">Sorts</Typography>
                {loadingSpells && <CircularProgress size={16} sx={{ ml: 'auto', color: selectedClass.color }} />}
                {!loadingSpells && (
                  <Typography className="wc-spell-count" sx={{ ml: 'auto' }}>
                    {allJsonSpells.length} sorts
                  </Typography>
                )}
              </Box>

              <Box className="wc-spell-grid">
                {allJsonSpells.map((sortData) => {
                  const isSelected = selectedSpell?.nom === sortData.nom;
                  return (
                    <Tooltip key={sortData.id || sortData.nom} title={sortData.nom} placement="top" arrow>
                      <Box
                        className={`wc-spell-item${isSelected ? ' wc-spell-item--active' : ''}`}
                        onClick={() => setSelectedSpell(sortData)}
                        sx={isSelected ? {
                          borderColor: `${selectedClass.color}88`,
                          background: `${selectedClass.color}15`,
                          boxShadow: `0 0 12px ${selectedClass.color}33`,
                        } : {
                          '&:hover .wc-spell-icon-wrap': {
                            borderColor: `${selectedClass.color}88`,
                            boxShadow: `0 0 16px ${selectedClass.color}44`,
                          },
                        }}
                      >
                        <Box className="wc-spell-icon-wrap">
                          <img
                            src={`/assets/spells/${sortData.icon_id ?? sortData.id}.svg`}
                            alt={sortData.nom}
                            className="wc-spell-icon"
                            loading="lazy"
                            onError={(e) => { e.target.style.opacity = '0.2'; }}
                          />
                        </Box>
                        <Typography className="wc-spell-name">{sortData.nom}</Typography>
                      </Box>
                    </Tooltip>
                  );
                })}
                {!loadingSpells && allJsonSpells.length === 0 && (
                  <Typography sx={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.85rem', p: 2, gridColumn: '1/-1' }}>
                    Données de sorts non disponibles
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Colonne droite : détail du sort sélectionné */}
            <Box className="wc-spell-detail-col">
              {selectedSpell ? (
                <SpellDetail
                  spellData={selectedSpell}
                  classColor={selectedClass.color}
                />
              ) : (
                <Box className="wc-detail-placeholder">
                  <img
                    src={`/assets/classes/${selectedClass.id}M.svg`}
                    alt=""
                    style={{ width: 64, height: 64, opacity: 0.15, marginBottom: 16 }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                  <Typography sx={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.9rem' }}>
                    Clique sur un sort pour voir ses détails
                  </Typography>
                </Box>
              )}
            </Box>

          </Box>
        </Box>
      )}

      {/* -- Placeholder désélectionné ---------------------------------- */}
      {!selectedClass && (
        <Box className="wc-placeholder">
          <Typography sx={{ fontSize: '3rem', mb: 1.5 }}>{'\u{1F52E}'}</Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.4)', fontWeight: 600 }}>
            Sélectionne une classe pour explorer ses sorts
          </Typography>
        </Box>
      )}

    </Box>
  );
};

export default WikiClasses;
